import invoiceDesignList from "dummydata/invoiceDesignList";
import { DELETE_INVOICE_DESIGN } from "redux/actionTypes/actionTypes";
import { ADD_INVOICE_DESIGN } from "redux/actionTypes/actionTypes";

const initialState = {
  invoiceDesignList: invoiceDesignList,
  invoiceTotal: 0,
};

const invoiceDesignReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_INVOICE_DESIGN:
      return {
        ...state,
        invoiceDesignList: state.invoiceDesignList.concat(action.payload),
      };
      break;
    case DELETE_INVOICE_DESIGN:
      return {
        ...state,
        invoiceDesignList: state.invoiceDesignList.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    default:
      break;
  }
  return state;
};
export default invoiceDesignReducer;
